module.exports = __webpack_public_path__ + "static/media/infocarro.5a5cd914.png";